import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '@/contexts/LanguageContext';
import api from '@/services/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = hash.split('session_id=')[1]?.split('&')[0];

    if (!sessionId) {
      navigate('/auth');
      return;
    }

    const processSession = async () => {
      try {
        const response = await api.post('/auth/process-session', { session_id: sessionId });

        if (response.data.success) {
          localStorage.setItem('user', JSON.stringify(response.data.user));
          navigate('/dashboard', { replace: true, state: { user: response.data.user } });
        } else {
          navigate('/auth');
        }
      } catch (error) {
        
        navigate('/auth');
      }
    };

    processSession();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#060B14] via-[#0C1527] to-[#060B14] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#E6C687] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-300">{t('authProcessing')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
